module.exports = __webpack_public_path__ + "img/logo17.ffb8bb2f.jpg";